import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isTokenBearingUrl } from '@/lib/analytics-privacy';
import { trackMetaPageView } from '@/lib/meta-pixel';
import { trackGaPageView } from '@/lib/google-analytics';

/**
 * Fires a page view (Meta Pixel + GA4) on initial load and on every client-side
 * route change. RegattaReplay is an SPA, so the router never triggers a full
 * document load — without this, analytics would record one page view per session.
 *
 * Page views are suppressed on token-bearing URLs (see isTokenBearingUrl) so we
 * never leak invite/confirm/claim/login tokens to Facebook or Google.
 *
 * Rendered once, inside the router. Renders nothing.
 */
export function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (isTokenBearingUrl(location.pathname, location.search)) return;
    trackMetaPageView();
    trackGaPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
